import { JSX } from 'react'

import { IconProps } from '../../icon'

const Responsive: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M24 32.6154H19.1426L19.9631 30.1538H22.359C23.0318 30.1538 23.5897 29.5959 23.5897 28.9231C23.5897 28.2503 23.0318 27.6923 22.359 27.6923H12.5128C11.3805 27.6923 10.4615 26.7733 10.4615 25.641V25.2308H22.359C23.0318 25.2308 23.5897 24.6728 23.5897 24C23.5897 23.3272 23.0318 22.7692 22.359 22.7692H10.4615V12.5128C10.4615 11.3805 11.3805 10.4615 12.5128 10.4615H33.8462C34.9785 10.4615 35.8974 11.3805 35.8974 12.5128V15.7949C35.8974 16.4677 36.4554 17.0256 37.1282 17.0256C37.801 17.0256 38.359 16.4677 38.359 15.7949V12.5128C38.359 10.0185 36.3405 8 33.8462 8H12.5128C10.0185 8 8 10.0185 8 12.5128V25.641C8 28.1354 10.0185 30.1538 12.5128 30.1538H17.3703L16.5497 32.6154H15.7949C15.1221 32.6154 14.5641 33.1733 14.5641 33.8462C14.5641 34.519 15.1221 35.0769 15.7949 35.0769H24C24.6728 35.0769 25.2308 34.519 25.2308 33.8462C25.2308 33.1733 24.6728 32.6154 24 32.6154Z'
      fill='black'
    />
    <path
      d='M37.1282 19.4872H28.9231C27.3477 19.4872 26.0513 20.7836 26.0513 22.359V37.1282C26.0513 38.7036 27.3477 40 28.9231 40H37.1282C38.7036 40 40 38.7036 40 37.1282V22.359C40 20.7836 38.7036 19.4872 37.1282 19.4872ZM37.5384 37.1282C37.5384 37.3579 37.3579 37.5385 37.1282 37.5385H28.9231C28.6933 37.5385 28.5128 37.3579 28.5128 37.1282V22.359C28.5128 22.1292 28.6933 21.9487 28.9231 21.9487H37.1282C37.3579 21.9487 37.5384 22.1292 37.5384 22.359V37.1282Z'
      fill='black'
    />
    <path
      d='M33.8462 32.6154H32.2051C31.5323 32.6154 30.9744 33.1733 30.9744 33.8462C30.9744 34.519 31.5323 35.0769 32.2051 35.0769H33.8462C34.519 35.0769 35.0769 34.519 35.0769 33.8462C35.0769 33.1733 34.519 32.6154 33.8462 32.6154Z'
      fill='black'
    />
  </svg>
)

export default Responsive
